export default __webpack_public_path__ + "static/media/8.4b99982e.png";